import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

interface CategoryFormProps {
  editingCategory: { id: string; name: string } | null;
  onSuccess: () => void;
}

export const CategoryForm = ({ editingCategory, onSuccess }: CategoryFormProps) => {
  const [newCategory, setNewCategory] = useState(editingCategory?.name || "");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!newCategory.trim()) {
      toast("تنبيه", {
        description: "يرجى إدخال اسم التصنيف"
      });
      return;
    }

    setIsSubmitting(true);

    try {
      if (editingCategory) {
        const { error } = await supabase
          .from('categories')
          .update({ name: newCategory.trim(), updated_at: new Date().toISOString() })
          .eq('id', editingCategory.id);

        if (error) throw error;
        toast("نجاح", {
          description: `تم تحديث التصنيف "${newCategory}" بنجاح`
        });
      } else {
        const { error } = await supabase
          .from('categories')
          .insert([{ name: newCategory.trim() }]);

        if (error) {
          if (error.code === '23505') {
            toast("خطأ", {
              description: "هذا التصنيف موجود مسبقاً"
            });
            return;
          }
          throw error;
        }
        toast("نجاح", {
          description: `تم إضافة التصنيف "${newCategory}" بنجاح`
        });
      }

      setNewCategory("");
      onSuccess();
    } catch (error) {
      console.error('Error saving category:', error);
      toast("خطأ", {
        description: "حدث خطأ أثناء حفظ التصنيف"
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>إضافة تصنيف جديد</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="flex gap-2">
          <Input
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            placeholder="اسم التصنيف..."
            className="text-right"
            required
          />
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : editingCategory ? (
              'تحديث'
            ) : (
              'إضافة'
            )}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};